/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import API from '@widgets/shared/API/connection';
const initialState = {
    level1: [],
    level2: [],
    level3: [],
    level4: [],
    currentLevel: 1,
    selectedOption: null,
};
export const activitiesSlice = createSlice({
    name: 'activityLevelsReducer',
    initialState,
    reducers: {
        setOptionAsSelected: (state, action) => {
            const { levelKey, activityId } = action.payload;
            state[levelKey] = [...state[levelKey]]
                .map((option) => ({ ...option, Selected: false }))
                .map((option) => ({
                ...option,
                Selected: (option.Value === activityId),
            }));
        },
        setCurrentLevel: (state, action) => {
            state.currentLevel = action.payload;
        },
        updateLevel: (state, action) => {
            const { key, value } = action.payload;
            state[key] = value;
        },
        removeLevel: (state, action) => {
            state[action.payload] = [];
        },
        clearLevels: (state) => {
            // TODO: I'm sure theres a nicer way of doing this....
            state.level2 = [];
            state.level3 = [];
            state.level4 = [];
        },
    },
});
export const { setCurrentLevel, setOptionAsSelected, updateLevel, removeLevel, clearLevels, } = activitiesSlice.actions;
export const selectOption = (option, level) => async (dispatch) => {
    const activities = await API.levelChange(option.Value);
    const nextLevel = level + 1;
    await dispatch(updateLevel({ key: `level${nextLevel}`, value: activities }));
    await dispatch(setOptionAsSelected({
        levelKey: `level${level}`,
        activityId: option.Value,
    }));
    await dispatch(setCurrentLevel(nextLevel));
};
export const goBackOneLevel = (level) => (dispatch) => Promise.all([
    dispatch(removeLevel(`level${level}`)),
    dispatch(setCurrentLevel(level - 1)),
]);
export const getAllActivityLevels = (state) => state.activities;
export const getActivityLevel = (key) => (state) => state.activities[key];
// eslint-disable-next-line max-len
export const getPreviousLevelSelected = (level) => (state) => {
    const activities = state.activities[level] ?? [];
    return activities.find((option) => option.Selected) ?? {};
};
export default activitiesSlice.reducer;
